module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-jack.ab81b016.svg";